"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOutboundPaymentsField = exports.UpdateOutboundPaymentType = void 0;
var UpdateOutboundPaymentType;
(function (UpdateOutboundPaymentType) {
    UpdateOutboundPaymentType["AMEND"] = "AMEND";
    UpdateOutboundPaymentType["FREEZE"] = "FREEZE";
    UpdateOutboundPaymentType["UNFREEZE"] = "UNFREEZE";
    UpdateOutboundPaymentType["STATUS_CHANGE"] = "STATUS_CHANGE";
    UpdateOutboundPaymentType["CANCEL"] = "CANCEL";
    UpdateOutboundPaymentType["SEND_INSTANT"] = "SEND_INSTANT";
    UpdateOutboundPaymentType["MANUAL_VOID"] = "MANUAL_VOID";
    UpdateOutboundPaymentType["MANUAL_FAIL"] = "MANUAL_FAIL";
})(UpdateOutboundPaymentType = exports.UpdateOutboundPaymentType || (exports.UpdateOutboundPaymentType = {}));
var UpdateOutboundPaymentsField;
(function (UpdateOutboundPaymentsField) {
    UpdateOutboundPaymentsField["PAYMENT_STATUS"] = "payment_status";
    UpdateOutboundPaymentsField["AMENDED"] = "amended";
    UpdateOutboundPaymentsField["FROZEN"] = "frozen";
    UpdateOutboundPaymentsField["OPERATION_NOTES"] = "operation_notes";
    UpdateOutboundPaymentsField["CANCELLED_REASON"] = "cancelled_reason";
    UpdateOutboundPaymentsField["FROZEN_REASON"] = "frozen_reason";
    UpdateOutboundPaymentsField["FAILURE_REASON"] = "failure_reason";
    UpdateOutboundPaymentsField["RELEASE_FLAG"] = "release_flag";
    UpdateOutboundPaymentsField["REFERENCE"] = "reference";
    UpdateOutboundPaymentsField["COUNTERPARTY"] = "counterparty";
    UpdateOutboundPaymentsField["PAYMENT_METHOD"] = "payment_method";
    UpdateOutboundPaymentsField["PURPOSE"] = "purpose";
})(UpdateOutboundPaymentsField = exports.UpdateOutboundPaymentsField || (exports.UpdateOutboundPaymentsField = {}));
